import { render } from "./App.vue?vue&type=template&id=5068a1c2"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./styles/main.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script